module.exports = __webpack_public_path__ + "static/media/blue_card_bg.1399c314.png";